import * as utils from '../utils.js';

class Magnet {

  constructor(el) {

	  this.DOM = {};
	  this.DOM.el = el;
    this.magnets = el.querySelectorAll('[data-magnet-ratio]');
	  this.init();

  }

  init() {

    this.mouseMoveFn = (e) => {

      let xMouse = e.pageX - e.currentTarget.getBoundingClientRect().left - ( e.currentTarget.offsetWidth / 2 );
		  let yMouse = e.pageY - window.pageYOffset - e.currentTarget.getBoundingClientRect().top - ( e.currentTarget.offsetHeight / 2 );

      this.magnets.forEach((magnet) => {
        TweenMax.to(magnet, 1.2, {x:xMouse * magnet.dataset.magnetRatio, y:yMouse * magnet.dataset.magnetRatio, ease:Power3.easeOut});
      })

	  }

	  this.mouseleaveFn = (e) => {
		  TweenMax.to(this.magnets, 1.2, {x:0, y:0, ease:Power3.easeOut});
	  }

    this.DOM.el.addEventListener('mousemove', this.mouseMoveFn);
	  this.DOM.el.addEventListener('mouseleave', this.mouseleaveFn);


  }

}

export default Magnet;
